import React, { memo } from 'react';
import LocaleLink from './locale-link';
import ExternalLinkIcon from '../images/external-link.svg';

export default memo(
	/**
	 * @param {{
	 *     addExternalIcon?: boolean,
	 *     externalIconClassName?: string,
	 *     externalClassName?: string,
	 *     internalClassName?: string,
	 *   } &
	 *   React.AnchorHTMLAttributes<HTMLAnchorElement>
	 * } props
	 */
	function Link({
		addExternalIcon = false,
		internalClassName,
		externalClassName,
		externalIconClassName,
		className,
		href,
		children,
		...rest
	}) {
		if (href === undefined) {
			return null;
		}

		// all "internal" links start with a "/"
		if (href.startsWith('/')) {
			return (
				<LocaleLink
					{...rest}
					className={internalClassName || className}
					to={href}
				>
					{children}
				</LocaleLink>
			);
		}

		return (
			<a
				{...rest}
				className={externalClassName || className}
				href={href}
			>
				{addExternalIcon && (
					<ExternalLinkIcon className={externalIconClassName} />
				)}
				{children}
			</a>
		);
	}
);
